import React from "react";
import cns from "classnames";
import { Grid } from "@material-ui/core";
import { ThemeType } from "@theme";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  left?: React.ReactNode;
  right?: React.ReactNode;
  fitted?: boolean;
  children?: React.ReactNode;
};

/**
 * For buttons and similar things
 */
function FormControls(props: Props) {
  const { children, fitted } = props;
  const classes = useStyles({});

  return (
    <Grid item xs={12} className={cns(classes.root, { [classes.padded]: !fitted })}>
      {(children || props.left) && <div>{children || props.left}</div>}

      <div className={classes.right}>{props.right}</div>
    </Grid>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    display: "flex",

    "& > div": {
      ...theme.mixins.childrenMarginRight(theme.spacing()),
      flex: "1 1 auto"
    }
  },

  padded: {
    margin: theme.spacing(2)
  },

  right: {
    display: "flex",
    justifyContent: "flex-end"
  }
}));

export default FormControls;
